import { useCallback, useLayoutEffect } from 'react';

import { useTimeout } from './timeout.hook';

export function useRemoveJiraWidget(ms = 1000) {
  const [debounceHide] = useTimeout();

  // get jsd-widget everytime to avoid different references
  const getWidget = useCallback((callback: (element: HTMLElement) => void) => {
    const widget = document.getElementById('jsd-widget');
    widget && callback(widget);
  }, []);

  useLayoutEffect(() => {
    let display: string | undefined;
    // temporarily hide by opacity
    getWidget(widget => {
      console.debug('[jsd-widget] opacity');
      widget.style.opacity = '0';
    });
    // debounce display hide so it renders properly again when needed
    const clear = debounceHide(() => {
      getWidget(widget => {
        display = widget.style.display;
        console.debug('[jsd-widget] hide display: %o', display);
        widget.style.display = 'none';
      });
    }, ms);
    return () => {
      clear();
      getWidget(widget => {
        console.debug('[jsd-widget] show display: %o', display);
        widget.style.opacity = '1';
        if (typeof display !== 'undefined') {
          widget.style.display = display;
        }
      });
    };
  }, [ms, debounceHide, getWidget]);
}
